/*
  @class
*/
class Operation {
  get _isOperation() { return true }
}

export default Operation
